import { render } from "./FooterContact.vue?vue&type=template&id=e56451ea&scoped=true&ts=true"
import script from "./FooterContact.vue?vue&type=script&lang=ts"
export * from "./FooterContact.vue?vue&type=script&lang=ts"

import "./FooterContact.vue?vue&type=style&index=0&id=e56451ea&lang=stylus&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e56451ea"]])

export default __exports__